"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = _interopRequireDefault(require("../index"));
var _automobile = _interopRequireDefault(require("./automobile"));
var _groundTransfer = _interopRequireDefault(require("./ground-transfer"));
var _memberRelationship = _interopRequireDefault(require("./member-relationship"));
var _transportation = _interopRequireDefault(require("./transportation"));
var version = "v1";
var _default = exports["default"] = {
  automobile: _automobile["default"],
  groundTransfer: _groundTransfer["default"],
  memberRelationship: _memberRelationship["default"],
  transportation: _transportation["default"],
  fetch: function fetch(id) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    params.include = "attributes";
    return _index["default"].get("/".concat(version, "/c/members/").concat(id, "/requests"), {
      params: params
    });
  },
  fetchById: function fetchById(id, type) {
    return _index["default"].get("/".concat(version, "/requests/").concat(type, "/").concat(id));
  },
  "delete": function _delete(id, type) {
    return _index["default"]["delete"]("/".concat(version, "/requests/").concat(type, "/").concat(id));
  },
  comment: function comment(id, family, notes) {
    var data = {
      description: notes
    };
    return _index["default"].post("/".concat(version, "/requests/").concat(family, "/").concat(id, "/comment"), data);
  },
  post: function post(family, attributes) {
    var payload = {
      data: {
        attributes: attributes,
        type: "request-".concat(family)
      }
    };
    return _index["default"].post("/".concat(version, "/requests/").concat(family), payload);
  }
};